var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"AppVersion"},[_vm._v("\n  version: "+_vm._s(_vm.version)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }